import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNotification, useTranslate } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { MagazineTemplate } from "@modules/magazineTemplates/types";
import { MagazineTemplateFormValues } from "@modules/magazineTemplates/validations";

import { editMagazineTemplateService } from "./service";
import { UseEditMagazineTemplateMutationOptions } from "./types";
import { listMagazineTemplatesQueryKey } from "../../queries";

export function useEditMagazineTemplateMutation(
  options?: UseEditMagazineTemplateMutationOptions
) {
  const queryClient = useQueryClient();

  const { open } = useNotification();
  const translate = useTranslate();

  return useMutation<
    MagazineTemplate,
    ApiError,
    { id: string; data: MagazineTemplateFormValues }
  >({
    mutationFn: ({ id, data }) => editMagazineTemplateService(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: listMagazineTemplatesQueryKey,
        refetchType: "all",
      });

      open?.({
        type: "success",
        message: translate("magazinetemplate_admin.success.edit"),
      });
    },
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
